





















import { isNumeric, notEmptyString } from "@/api/validators";
import { bus } from "@/main";
import { SubNavItem } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import sortableElement from "../../api/sortable";

@Component
export default class SubmissionNav extends Vue {
  @Prop({ default: () => [] }) workItems: Array<SubNavItem>;
  @Prop({ default: "top-submission-sort" }) navId: string;
  @Prop({ default: "" }) title: string;

  hoverIndex = -1;
  dropIndex = -1;

  get items(): Array<SubNavItem> {
    return this.workItems.map((sub, workIndex) => {
      const type = sub.active ? "is-primary" : "is-light";
      const keyParts = sub.key.split("-");
      const firstClass = "work";
      const classNames = [firstClass];
      if (workIndex === this.hoverIndex || workIndex === this.dropIndex) {
        classNames.push("selected");
      }
      workIndex = parseInt(keyParts.pop(), 10);
      classNames.push([keyParts.shift(), workIndex].join("-"));
      return { ...sub, type, classNames, workIndex };
    });
  }

  goTo(key: string) {
    bus.$emit("goto", key);
  }

  mounted() {
    setTimeout(this.initSortable, 1000);
  }

  get infoTitle() {
    return notEmptyString(this.title, 3)? this.title : 'Drag these icons up and down to re-order your containers';
  }

  initSortable() {
    const element = document.getElementById(this.navId);
    sortableElement(element, ".handle", (e) => {
      const { newIndex, oldIndex, target } = e;
      if (newIndex < target.childNodes.length) {
        const tgEl = target.childNodes[newIndex];
        if (tgEl.classList.contains("work")) {
          const wid = tgEl.getAttribute("data-wid");
          if (isNumeric(wid) && oldIndex >= 0) {
            const oldWorkIndex = parseInt(wid, 10);
            const newWorkIndex = newIndex;
            bus.$emit("sort-works", { oldWorkIndex, newWorkIndex });
            this.dropIndex = newIndex;
            setTimeout(() => {
              this.dropIndex = -1;
              this.hoverIndex = -1;
            }, 2000);
          }
        }
      }
    });
  }

  setIndex(index: number) {
    this.hoverIndex = index;
  }

  close() {
    bus.$emit("escape", true);
  }
}
